export default {
  dynamics: '{{change}} vs. edellinen {{time_unit}}',
};
